import isArray from 'lodash-es/isArray'

import { EMPTY_LIST, EMPTY_STRING } from '../../constants/common'
import { getItemsFromApiResponse } from '../../utils/api'
import { isValueStringType } from '../../utils/common'

import {
  AI_TEXT_GENERATION_SERVER_ERROR_STATUSES,
  AI_TEXT_GENERATION_SERVER_ERRORS,
  AITextGenerationLocalContextType,
  AITextGenerationType,
} from './AITextGeneration.constants'

export function normalizeAITextGenerationTemplateOptions(response) {
  const objects = getItemsFromApiResponse(response)

  if (!isArray(objects)) {
    return EMPTY_LIST
  }

  return objects
    .map(item => {
      const id = item.id
      const label = item.title || item.name

      if (!id || !label) {
        return null
      }

      return {
        label,
        raw: item,
        value: String(id),
      }
    })
    .filter(Boolean)
}

export function getAITextGenerationTemplateSelectValueProps() {
  return { value: null }
}

export function isAITextGenerationTypeEmail(type) {
  return type === AITextGenerationType.Email
}

export function isAITextGenerationLocalContextTypeServiceRequestEmail(type) {
  return type === AITextGenerationLocalContextType.ServiceRequestEmail
}

export function getAITextGenerationTranscriptBudget(snapshot, maxLength) {
  const safeSnapshot = snapshot || EMPTY_STRING

  if (!safeSnapshot) {
    return maxLength
  }

  const joinerLength = /\s$/.test(safeSnapshot) ? 0 : 1

  return Math.max(0, maxLength - safeSnapshot.length - joinerLength)
}

export function isAITextGenerationSettingsChanged({
  currentLength,
  currentTone,
  hasPrompt,
  lastSubmittedSettings,
  promptValue,
}) {
  return lastSubmittedSettings
    ? currentTone !== lastSubmittedSettings.tone ||
        currentLength !== lastSubmittedSettings.length ||
        (hasPrompt && promptValue !== lastSubmittedSettings.prompt)
    : false
}

export function parseAITextGenerationServerError(error, t) {
  const status = error?.response?.status

  if (AI_TEXT_GENERATION_SERVER_ERROR_STATUSES[status]) {
    return t(AI_TEXT_GENERATION_SERVER_ERROR_STATUSES[status])
  }

  const errors = error?.response?.data?.errors

  // Validation errors can be a nested object (e.g. { local_context: { object_id } }).
  // Such a value must never be returned as-is — it would be rendered as a React child
  // and crash the page. Fall back to the generic error message in that case.
  if (!isValueStringType(errors)) {
    return null
  }

  if (AI_TEXT_GENERATION_SERVER_ERRORS[errors]) {
    return t(AI_TEXT_GENERATION_SERVER_ERRORS[errors])
  }

  return errors || null
}
